"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _functionalButton = require("@widget/functional-button");

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _useDebouncedEffect = require("use-debounced-effect");

var _react = _interopRequireWildcard(require("react"));

var _useGetRecipientShops = _interopRequireDefault(require("../hooks/useGetRecipientShops"));

var _useGetSelectedAccount = _interopRequireDefault(require("../hooks/useGetSelectedAccount"));

var _useGetSelectedRecipientShop = _interopRequireDefault(require("../hooks/useGetSelectedRecipientShop"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var DEBIT_DIRECTION = 'debit';
var CREDIT_DIRECTION = 'credit';

function useGetRecipientsBySelectedSenderShop(shop) {
  return (0, _react.useMemo)(function () {
    if (!shop) {
      return [];
    }

    var newRecipients = [];

    for (var key in shop['transferRoutes']) {
      if (shop['transferRoutes'].hasOwnProperty(key)) {
        var newRecipientId = shop['transferRoutes'][key]['receiverShopId'];
        newRecipients.push(newRecipientId);
      }
    }

    return newRecipients;
  }, [shop]);
}

function amountDebitValidate(values) {
  if (!values['amount-debit']) {
    return false;
  } else if (!/^\d+(\.\d{1,2})?$/.test(values['amount-debit'])) {
    // eslint-disable-next-line
    return false;
  } else if (Number(values['amount-debit']) <= 0) {
    return false;
  } else if (Number(values['amount-debit']) > Number(values['account']['available'])) {
    return false;
  }

  return true;
}

function amountCreditValidate(values) {
  if (!values['amount-credit']) {
    return false;
  } else if (!/^(\d+)(\.\d{1,2})?$/.test(values['amount-credit'])) {
    // eslint-disable-next-line
    return false;
  } else if (Number(values['amount-credit']) <= 0) {
    return false;
  }

  return true;
}

function ModifyForm(_ref) {
  var recipientsShops = _ref.recipientsShops,
      senderShops = _ref.senderShops,
      accounts = _ref.accounts,
      handleSubmit = _ref.handleSubmit,
      disabled = _ref.disabled,
      valid = _ref.valid,
      pristine = _ref.pristine;

  try {
    var handleSetNewCurrency = function handleSetNewCurrency() {
      dispatch((0, _reduxForm.change)('transfer-create', 'amount', null));
      dispatch((0, _reduxForm.change)('transfer-create', 'amount-debit', null));
      dispatch((0, _reduxForm.change)('transfer-create', 'amount-credit', null));
    };

    var handleChangeFlag = function handleChangeFlag(direction) {
      setDirection(direction);
    };

    var dispatch = (0, _reactRedux.useDispatch)();

    var _useState = (0, _react.useState)(0),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        commission = _useState2[0],
        setCommission = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
        hasChanged = _useState4[0],
        setChanged = _useState4[1];

    var _useState5 = (0, _react.useState)(DEBIT_DIRECTION),
        _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
        direction = _useState6[0],
        setDirection = _useState6[1];

    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInSubmitProcess);
    var formValues = (0, _reactRedux.useSelector)((0, _reduxForm.getFormValues)('transfer-create'));
    var recipientShops = (0, _useGetRecipientShops["default"])();
    var defaultRecipientShop = (0, _useGetSelectedRecipientShop["default"])(recipientShops);
    var selectAccount = (0, _useGetSelectedAccount["default"])(accounts);
    var recipientShopIds = useGetRecipientsBySelectedSenderShop(formValues['sender']);
    (0, _react.useEffect)(function () {
      dispatch((0, _reduxForm.change)('transfer-create', 'sender', formValues['sender']));
      dispatch((0, _reduxForm.change)('transfer-create', 'account', null));
      dispatch((0, _reduxForm.change)('transfer-create', 'amount', null));
      dispatch((0, _reduxForm.change)('transfer-create', 'amount-debit', null));
      dispatch((0, _reduxForm.change)('transfer-create', 'amount-credit', null));
    }, [formValues['sender']]);
    (0, _react.useEffect)(function () {
      dispatch((0, _reduxForm.change)('transfer-create', 'recipient', defaultRecipientShop));
    }, [defaultRecipientShop]);
    (0, _react.useEffect)(function () {
      dispatch((0, _reduxForm.change)('transfer-create', 'account', selectAccount, false));
    }, [selectAccount]);
    (0, _react.useEffect)(function () {
      function init() {
        return _init.apply(this, arguments);
      }

      function _init() {
        _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!recipientShopIds.length) {
                    _context.next = 4;
                    break;
                  }

                  dispatch((0, _reduxForm.change)('transfer-create', 'recipient', null));
                  _context.next = 4;
                  return dispatch((0, _functionalButton.getTransferRecipientShops)({
                    shops: recipientShopIds
                  }));

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return _init.apply(this, arguments);
      }

      init();
    }, [formValues['sender']]);
    (0, _react.useEffect)(function () {
      function init() {
        return _init2.apply(this, arguments);
      }

      function _init2() {
        _init2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
          var result;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (hasChanged) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return", void 0);

                case 2:
                  if (formValues['sender']['isShowCommissionCalculation']) {
                    _context2.next = 5;
                    break;
                  }

                  setChanged(false);
                  return _context2.abrupt("return", void 0);

                case 5:
                  if (!(direction === DEBIT_DIRECTION)) {
                    _context2.next = 12;
                    break;
                  }

                  if (amountDebitValidate(formValues)) {
                    _context2.next = 10;
                    break;
                  }

                  dispatch((0, _reduxForm.blur)('transfer-create', 'amount-debit', formValues['amount-debit'], true));
                  setChanged(false);
                  return _context2.abrupt("return", void 0);

                case 10:
                  _context2.next = 17;
                  break;

                case 12:
                  if (!(direction === CREDIT_DIRECTION)) {
                    _context2.next = 17;
                    break;
                  }

                  if (amountCreditValidate(formValues)) {
                    _context2.next = 17;
                    break;
                  }

                  dispatch((0, _reduxForm.blur)('transfer-create', 'amount-credit', formValues['amount-credit'], true));
                  setChanged(false);
                  return _context2.abrupt("return", void 0);

                case 17:
                  _context2.prev = 17;
                  setCommission(0);
                  _context2.next = 21;
                  return dispatch((0, _functionalButton.getCommission)({
                    method: {
                      id: 24
                    },
                    shop: formValues['sender'],
                    account: formValues['account'],
                    'amount-debit': formValues['amount-debit'],
                    'amount-credit': formValues['amount-credit']
                  }, direction === DEBIT_DIRECTION));

                case 21:
                  result = _context2.sent;

                  if (result) {
                    if (direction === DEBIT_DIRECTION) {
                      setCommission(result['amountCommission']);
                      dispatch((0, _reduxForm.change)('transfer-create', 'amount-credit', String(result['amountCredit'])));
                    } else if (direction === CREDIT_DIRECTION) {
                      setCommission(result['amountCommission']);
                      dispatch((0, _reduxForm.change)('transfer-create', 'amount-debit', String(result['amountDebit'])));
                    }
                  }

                  _context2.next = 28;
                  break;

                case 25:
                  _context2.prev = 25;
                  _context2.t0 = _context2["catch"](17);
                  console.log('debit error', _context2.t0);

                case 28:
                  setChanged(false);

                case 29:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[17, 25]]);
        }));
        return _init2.apply(this, arguments);
      }

      init();
    }, [hasChanged, direction]);
    (0, _useDebouncedEffect.useDebouncedEffect)(function () {
      if (direction !== DEBIT_DIRECTION) {
        return void 0;
      }

      setChanged(true);
    }, 800, [formValues['amount-debit'], formValues['account']]);
    (0, _useDebouncedEffect.useDebouncedEffect)(function () {
      if (direction !== CREDIT_DIRECTION) {
        return void 0;
      }

      setChanged(true);
    }, 800, [formValues['amount-credit']]);

    var Option = function Option(_ref2) {
      var item = _ref2.item,
          maxId = _ref2.maxId,
          locator = _ref2.locator;
      var n = maxId.toString().length;
      var width = 10;
      var style = {
        width: maxId === 0 ? 'auto' : (n + 1) * width + 'px'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['option'],
        title: item['name']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        className: _defaultModule["default"]['option__id']
      }, "\u2116", item['id']), /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['option__name'],
        "data-locator": "".concat(locator, ".select.value")
      }, item['name']));
    };

    var maxSenderShopId = Math.max.apply(Math, (0, _toConsumableArray2["default"])(senderShops.map(function (item) {
      return item.id;
    })));
    var maxRecipientShopId = Math.max.apply(Math, (0, _toConsumableArray2["default"])(recipientsShops.map(function (item) {
      return item.id;
    })));
    return /*#__PURE__*/_react["default"].createElement("form", {
      className: _defaultModule["default"]['dialog'],
      "data-locator": "transfer.dialog",
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement("article", {
      className: _defaultModule["default"]['dialog__content'],
      "data-locator": "transfer.dialog.content"
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: _defaultModule["default"]['dialog__section']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      label: "\u041C\u0430\u0433\u0430\u0437\u0438\u043D \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C",
      name: "sender",
      useKey: false,
      optionKey: "id",
      optionTemplate: function optionTemplate(item) {
        return /*#__PURE__*/_react["default"].createElement(Option, {
          item: item,
          maxId: maxSenderShopId,
          locator: 'sender'
        });
      },
      valueTemplate: function valueTemplate(item) {
        return /*#__PURE__*/_react["default"].createElement(Option, {
          item: item,
          maxId: 0,
          locator: 'sender'
        });
      },
      simple: false,
      clearable: false,
      options: senderShops,
      disabled: disabled || inProcess,
      required: true
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      label: "\u041C\u0430\u0433\u0430\u0437\u0438\u043D \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C",
      name: "recipient",
      optionKey: "id",
      useKey: false,
      optionTemplate: function optionTemplate(item) {
        return /*#__PURE__*/_react["default"].createElement(Option, {
          item: item,
          maxId: maxRecipientShopId,
          locator: 'recipient'
        });
      },
      valueTemplate: function valueTemplate(item) {
        return /*#__PURE__*/_react["default"].createElement(Option, {
          item: item,
          maxId: 0,
          locator: 'recipient'
        });
      },
      clearable: false,
      simple: false,
      options: recipientsShops,
      disabled: disabled || inProcess || !formValues['sender'],
      required: true
    })))), /*#__PURE__*/_react["default"].createElement("section", {
      className: _defaultModule["default"]['dialog__section']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.TextareaField, {
      label: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 \u043A \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0443",
      name: "description",
      disabled: disabled || inProcess || !formValues['sender'] || !formValues['recipient'],
      required: true
    }))), formValues['sender'] && !formValues['sender']['isShowCommissionCalculation'] && /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper__field']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "\u0421\u0443\u043C\u043C\u0430 \u0437\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F",
      name: "amount",
      disabled: disabled || inProcess || !formValues['sender'] || !formValues['recipient'] || !formValues['description'],
      onChange: function onChange() {
        return handleChangeFlag(DEBIT_DIRECTION);
      },
      required: true
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper__currency']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      label: "\u0412\u0430\u043B\u044E\u0442\u0430",
      placeholder: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0430\u043B\u044E\u0442\u0443",
      name: "account",
      clearable: false,
      options: accounts,
      disabled: disabled || inProcess || !formValues['sender'] || !formValues['recipient'] || !formValues['description'],
      onSelect: function onSelect() {
        return handleSetNewCurrency();
      },
      isLoading: true,
      required: true
    }))))), formValues['sender'] && formValues['sender']['isShowCommissionCalculation'] && /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper__field']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "\u0421\u0443\u043C\u043C\u0430 \u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F",
      name: "amount-debit",
      disabled: disabled || inProcess || !formValues['sender'] || !formValues['recipient'] || !formValues['description'],
      onFocus: function onFocus() {
        return handleChangeFlag(DEBIT_DIRECTION);
      },
      required: true
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper__currency']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      label: "\u0412\u0430\u043B\u044E\u0442\u0430",
      placeholder: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0430\u043B\u044E\u0442\u0443",
      name: "account",
      clearable: false,
      simple: false,
      options: accounts,
      disabled: disabled || inProcess || !formValues['sender'] || !formValues['recipient'] || !formValues['description'],
      onSelect: function onSelect() {
        return handleSetNewCurrency();
      },
      isLoading: true,
      required: true
    }))))), formValues['sender'] && formValues['sender']['isShowCommissionCalculation'] && /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper__field']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "\u0421\u0443\u043C\u043C\u0430 \u0437\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F",
      name: "amount-credit",
      disabled: disabled || inProcess || !formValues['sender'] || !formValues['recipient'] || !formValues['description'],
      onFocus: function onFocus() {
        return handleChangeFlag(CREDIT_DIRECTION);
      },
      required: true
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper__currency']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['currency'],
      "data-locator": "transfer.amount.credit.currency"
    }, formValues['account'] && formValues['account']['name']))))), formValues['sender'] && formValues['sender']['isShowCommissionCalculation'] && /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['commission_amount'],
      "data-locator": "transfer.commission"
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment'
    }, "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F: ", commission, " ", formValues['account'] && formValues['account']['name'])))))), /*#__PURE__*/_react["default"].createElement("footer", {
      className: _defaultModule["default"]['dialog__controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": "transfer.submit",
      type: "submit",
      mode: "success",
      inProcess: inProcess,
      disabled: !valid || pristine
    }, "\u041F\u0435\u0440\u0435\u0432\u0435\u0441\u0442\u0438"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['dialog__controls-note']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment'
    }, "\u0412\u0441\u0435 \u043F\u043E\u043B\u044F, \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u0435 \u0437\u0432\u0435\u0437\u0434\u043E\u0447\u043A\u043E\u0439,", /*#__PURE__*/_react["default"].createElement("br", null), "\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F"))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = ModifyForm;
exports["default"] = _default;